<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableUser ref="table" :showTitle="false" :companyId="companyId" :isCompanyView="true" :inCompany="true"/>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()" color="primary">Neu erstellen</v-btn>
    </v-col>

  </v-row>
</template>

<script>
import Vue from 'vue'
import TableUser from "../../tables/TableUser";

export default {
  name: 'TabPlaylist',
  components: {TableUser},
  props: {
    companyId: String,
    companyOwnerID: String
  },
  methods: {
    open: function () {
      this.$refs.table.reload()
    },
    createItem: function () {
      var cmp = this
      Vue.prototype.$apiUser.createUser({
        guidParent: cmp.companyId
      }, this.onTimeCreated)
    },
    onTimeCreated: function (newItem) {
      if (this.companyOwnerID) {
        this.$router.push('/Netzwerke/' + this.companyOwnerID + '/Standort/' + this.companyId + '/Benutzer/' + newItem.guid)
      } else {
        this.$router.push('/Netzwerke/' + this.companyId + '/Benutzer/' + newItem.guid)
      }

    }
  },
  data () {
    return {}
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
